import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { transactionsApi } from '../../services/rest/apiInstances';
import { Transaction } from '@/api/general';
import { buildClientApiConfig } from '@/helpers/apiRequestConfig';

export const fetchTransactionList = createAsyncThunk(
    'transactions/fetchTransactionList',
    async (filters: any) => {
        try {
            const options = buildClientApiConfig();
            const data = await transactionsApi.listTransactions(filters, options);
            return data.data;
        } catch (error: any) {
            return error.data;
        }
    },
);

export interface ITransactionsState {
    isPending: boolean;
    errors: any;
    transactionList: any[];
    isOpenTransactionDetailModal: boolean;
    transactionDetailToDisplay: any;
    relatedTransactionsList: any[];
}

const initialState: ITransactionsState = {
    isPending: false,
    errors: null,
    transactionList: [],
    isOpenTransactionDetailModal: false,
    transactionDetailToDisplay: undefined,
    relatedTransactionsList: [],
};

export const transactionSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {
        openTransactionModal: (state: any, action: PayloadAction<any>) => {
            state.isOpenTransactionDetailModal = true;
            state.transactionDetailToDisplay = action.payload;
            if (action?.payload?.relatedTransactionIds) {
                const foundRelatedTransactions: any = [];

                action?.payload?.transactionList?.map((transaction: Transaction) => {
                    if (action?.payload?.relatedTransactionIds?.includes(transaction.id)) {
                        foundRelatedTransactions.push(transaction);
                    }
                });

                state.relatedTransactionsList = foundRelatedTransactions;
            }
        },
        closeTransactionModal: (state) => {
            state.isOpenTransactionDetailModal = false;
            state.transactionDetailToDisplay = undefined;
            state.relatedTransactionsList = [];
        },
        setTransactionDetailToDisplay: (state, action: PayloadAction<any>) => {
            state.transactionDetailToDisplay = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTransactionList.pending, (state) => {
                state.isPending = true;
            })
            .addCase(fetchTransactionList.rejected, (state, action) => {
                state.isPending = false;
                state.errors = action.error;
            })
            .addCase(fetchTransactionList.fulfilled, (state, action) => {
                const transactions = action.payload?.transactions;
                state.isPending = false;
                if (transactions) {
                    state.transactionList = transactions;
                }
            });
    },
});

export const { openTransactionModal, closeTransactionModal, setTransactionDetailToDisplay } =
    transactionSlice.actions;

export default transactionSlice.reducer;
